import * as React from 'react';
import { useContext } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import { CloudDownload } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { RootStoreContext } from '../../App';

function BulkTemplateDownloadButton() {
    const rootStore = useContext(RootStoreContext);
    const { t } = useTranslation('timeentries');

    return (
        <Tooltip title={t('header.action.bulk_download.tooltip')}>
            <IconButton
                key={'download'}
                onClick={rootStore.bulkUploadStore.downloadBulkTemplate}
            >
                <CloudDownload />
            </IconButton>
        </Tooltip>
    );
}

export default BulkTemplateDownloadButton;